<template>
  <div>
    <v-card class="pa-4">
      <div class="text-xs-right">
        <v-btn @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
      </div>
      <v-layout class="mb-4">
        <v-flex>
          <v-btn
            @click="onChangeType('usedCode')"
            :class="currentView == 'usedCode' ? 'primary' : 'gray'"
          >
            <span>Code ที่ส่งไปแล้ว</span>
          </v-btn>
          <v-btn
            @click="onChangeType('availableCode')"
            :class="currentView == 'availableCode' ? 'primary' : 'gray'"
          >
            <span>Code ที่เหลือ</span>
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn @click="onExport" :loading="loading">
            <em class="fas fa-file-export" />
            &nbsp;
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div>
        <v-data-table
          :headers="headers"
          :items="allCodes"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td v-if="currentView == 'usedCode'">{{ props.item.first_name }}</td>
              <td>
                {{
                  props.item.code_1 == '' || props.item.code_1 == '-'
                    ? props.item.code
                    : props.item.code_1
                }}
              </td>
              <td>{{ props.item.code_2 }}</td>
              <td>{{ props.item.code_3 }}</td>
              <td>{{ props.item.code_4 }}</td>
              <td>{{ props.item.code_5 }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="mt-3 text-xs-center">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  props: ['selectedCampaign'],
  data() {
    return {
      campaignId: null,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      allCodes: [],
      loading: false,
      currentView: 'usedCode'
    }
  },
  async mounted() {
    if (this.selectedCampaign) {
      this.campaignId = this.selectedCampaign.campaign_id
      var { codes, total } = await this.getFollowMessagesReportNewUsedCodes()
      this.allCodes = codes
      this.total = total
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    headers() {
      if (this.currentView == 'usedCode') {
        return [
          { text: 'Name', value: 'first_name', sortable: false },
          { text: 'Code_1', value: 'Code_1', sortable: false },
          { text: 'Code_2', value: 'Code_2', sortable: false },
          { text: 'Code_3', value: 'Code_3', sortable: false },
          { text: 'Code_4', value: 'Code_4', sortable: false },
          { text: 'Code_5', value: 'Code_5', sortable: false }
        ]
      } else {
        return [
          { text: 'Code_1', value: 'Code_1', sortable: false },
          { text: 'Code_2', value: 'Code_2', sortable: false },
          { text: 'Code_3', value: 'Code_3', sortable: false },
          { text: 'Code_4', value: 'Code_4', sortable: false },
          { text: 'Code_5', value: 'Code_5', sortable: false }
        ]
      }
    }
  },
  methods: {
    async onExport() {
      this.loading = true
      let json = [
        {
          'Campaign Name': this.selectedCampaign.name,
          'Start Date': this.selectedCampaign.start_date
            ? moment(this.selectedCampaign.start_date).format('DD/MM/YYYY')
            : '-',
          'End Date': this.selectedCampaign.end_date
            ? moment(this.selectedCampaign.end_date).format('DD/MM/YYYY')
            : '-',
          Message: this.selectedCampaign.messages,
          'จำนวน Code ทั้งหมด': this.selectedCampaign.total_codes || 0,
          'จำนวน Code ที่ส่งไปแล้ว': this.selectedCampaign.total_codes_used || 0,
          'จำนวน Code ที่เหลือ': this.selectedCampaign.total_codes_available || 0
        }
      ]

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)

      let codes = await this.exportFollowMessagesReport()

      json = [
        ...(codes
          ? codes.codes.map((el) => ({
              CODE: el.code || '',
              'LINE ID': el.lineid,
              'LINE NAME': el.linename,
              STATUS: el.status
            }))
          : [])
      ]

      const dataWS2 = XLSX.utils.json_to_sheet(json)
      XLSX.utils.book_append_sheet(wb, dataWS2)
      XLSX.writeFile(wb, 'export_code.xlsx')
      this.loading = false
    },
    async exportFollowMessagesReport() {
      let request = {
        pageid: this.selectedBot.pageid,
        campaignid: this.campaignId,
        params: {
          limit: this.limit,
          offset: this.offset
        }
      }

      this.loading = true
      let response = await api.exportFollowMessagesReport(request)

      this.loading = false
      if (response.status == true) {
        return {
          codes: response.result || [],
          total: response.result ? response.result.length : 0
        }
      } else
        return {
          codes: [],
          total: 0
        }
    },
    async getFollowupMessageReportAvailableCodes() {
      let request = {
        pageid: this.selectedBot.pageid,
        campaign_id: this.campaignId,
        params: {
          limit: this.limit,
          offset: this.offset
        }
      }

      this.loading = true
      let response = await api.getFollowupMessageReportAvailableCodes(request)

      this.loading = false
      if (response.status == true) {
        return {
          codes: response.codes || [],
          total: response.codes ? response.codes.length : 0
        }
      } else
        return {
          codes: [],
          total: 0
        }
    },
    async getFollowMessagesReportNewUsedCodes() {
      let request = {
        pageid: this.selectedBot.pageid,
        campaign_id: this.campaignId,
        params: {
          limit: this.limit,
          offset: this.offset
        }
      }

      this.loading = true
      let response = await api.getFollowMessagesReportNewUsedCodes(request)

      this.loading = false
      if (response.status == true) {
        return {
          codes: response.codes || [],
          total: response.codes ? response.codes.length : 0
        }
      } else
        return {
          codes: [],
          total: 0
        }
    },
    async changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        let { codes, total } = await this.getFollowupMessageReportAvailableCodes()
        this.allCodes = codes
        this.total = total
      }
    },
    async onChangeType(view) {
      this.currentView = view
      if (view == 'usedCode') {
        var { codes, total } = await this.getFollowMessagesReportNewUsedCodes()
      } else {
        var { codes, total } = await this.getFollowupMessageReportAvailableCodes()
      }

      this.allCodes = codes
      this.total = total
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ReportCodeDialog.vue